<template>
  <div class="description">
    <div class="description__body-wrapper">
      <p class="description__body-wrapper__text" :style="themeStyles">
        {{ description }}
      </p>
    </div>
    <button
      v-show="description.length > descriptionLimit"
      class="description__button"
      :style="themeStyles"
      @click="open"
    >
      Read More
    </button>
    <div class="description__button-placeholder" v-show="description.length <= descriptionLimit"></div>
    <modal v-if="isVisible" @close="close">
      <template #header>
        <h2 class="description__heading">Show Notes</h2>
      </template>
      <template #body>{{ description }}</template>
    </modal>
  </div>
</template>

<script>
import Modal from './Utils/Modal';

export default {
  components: {
    Modal,
  },
  props: {
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
    description: String,
  },
  data() {
    return {
      descriptionLimit: 120,
      isVisible: false,
    };
  },
  computed: {
    themeStyles() {
      return {
        color: this.theme.text,
      };
    },
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/variables-v2';

.description {
  font-family: $font;
  line-height: 1.5;

  &__body-wrapper {
    &__text {
      height: 50px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  &__button {
    padding: 0;
    margin: 0;
    background: transparent;
    border: 0;
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    &:hover {
      opacity: 0.8;
    }
  }
  &__button-placeholder {
    height: 24px;
  }
  &__heading {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
}
</style>
